import { render } from "./starting-point.vue?vue&type=template&id=0f05e0ea&scoped=true&ts=true"
import script from "./starting-point.vue?vue&type=script&lang=ts"
export * from "./starting-point.vue?vue&type=script&lang=ts"

import "./starting-point.vue?vue&type=style&index=0&id=0f05e0ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f05e0ea"]])

export default __exports__